<script>
import Button from "@/shared/ui/button/Button.vue";
import Checkbox from "@/shared/ui/checkbox/Checkbox.vue";
import { FormSheet } from "@/shared/ui/form-sheet";
import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";

export default {
  name: "AddCustomFields",
  components: {
    Button,
    Checkbox,
    FormSheet,
    Input,
    Label,
  },

  props: {
    editingKey: {
      type: String,
      default: null,
    },
    template: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,

      form: {
        name: "",
        name_kz: "",
        code: "",
        favourites: false,
        original_code: null,
      },

      errors: {},
    };
  },
  computed: {
    title() {
      return this.editingKey
        ? this.$t("Редактирование поля")
        : this.$t("Добавление поля");
    },
  },
  mounted() {
    this.visible = true;
    if (this.editingKey && this.template) {
      const field = this.template?.fields[this.editingKey];
      this.form = {
        code: this.editingKey || field.code,
        original_code: this.editingKey,
        name: field.name,
        name_kz: field.name_kz,
        favourites: field.favourites,
      };
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("close");
    },
    validate() {
      this.errors = {};
      let valid = true;
      if (!this.form.code) {
        this.errors.code = true;
        valid = false;
      }
      if (!this.form.name) {
        this.errors.name = true;
        valid = false;
      }
      if (!this.form.name_kz) {
        this.errors.name_kz = true;
        valid = false;
      }
      return valid;
    },
    save() {
      if (this.validate()) {
        this.$emit("save", { ...this.form });
        this.handleClose();
      }
    },
    remove() {
      this.$emit("remove", this.editingKey);
      this.handleClose();
    },
  },
};
</script>

<template>
  <FormSheet
    v-model:open="visible"
    :title="title"
    :description="$t('Кастомные поля')"
    :width="500"
    @close="handleClose"
  >
    <div class="flex flex-col gap-3 w-full">
      <div class="flex flex-col gap-1.5 w-full">
        <Label class="text-xs text-muted-foreground">{{ $t("Ключ") }}</Label>
        <Input
          v-model="form.code"
          :class="{ 'border-destructive': errors.code }"
        />
      </div>
      <div class="flex flex-col gap-1.5 w-full">
        <Label class="text-xs text-muted-foreground">{{
          $t("Наименование поля (рус)")
        }}</Label>
        <Input
          v-model="form.name"
          :class="{ 'border-destructive': errors.name }"
        />
      </div>
      <div class="flex flex-col gap-1.5 w-full">
        <Label class="text-xs text-muted-foreground">{{
          $t("Наименование поля (қаз)")
        }}</Label>
        <Input
          v-model="form.name_kz"
          :class="{ 'border-destructive': errors.name_kz }"
        />
      </div>
      <div>
        <Checkbox v-model="form.favourites" style="color: #0a0c11">
          {{ $t("Добавить в избранные") }}
        </Checkbox>
      </div>
    </div>

    <template #footer>
      <Button
        v-if="editingKey"
        variant="destructive"
        size="default"
        @click="remove"
      >
        {{ $t("Удалить") }}
      </Button>
      <div class="flex-1"></div>
      <Button variant="outline" size="default" @click="handleClose">
        {{ $t("Отмена") }}
      </Button>
      <Button class="ml-2" size="default" @click="save">
        {{ $t("Сохранить") }}
      </Button>
    </template>
  </FormSheet>
</template>

<style scoped lang="scss"></style>
